const fieldNames = [
  'CounselorLed',
  'TeacherLed',
  'ImplementationType',
  'ClassCreationGoalDate',
  'ClassCreationGoalValue',
  'LessonCompletionGoalDate',
  'LessonCompletionGoalValue',
  'ProgramStartDate',
  'LessonCompletionGoalIsDisabled',
  'Purpose',
]

export const addProgressToSites = (sites, publishFlows, structureVersion) => {
  return sites.map(site => {
    const sitePublishFlows = publishFlows.filter(
      flow => flow?.siteId === site.id,
    )
    let planProgressNumber = 0
    let planProgressStatus = 'Not Started'
    let launchProgressNumber = 0
    let launchProgressStatus = 'Not Started'
    const currentPublishFlow = sitePublishFlows.find(
      flow => flow?.publishFlowStructureId === structureVersion,
    )

    const publishFlowItems = {}

    fieldNames.forEach(fieldName => {
      publishFlowItems[fieldName] = currentPublishFlow?.publishFlowItems?.find(
        item => item.name === fieldName,
      )?.completeValue
      if (
        fieldName === 'CounselorLed' ||
        fieldName === 'TeacherLed' ||
        fieldName === 'LessonCompletionGoalIsDisabled'
      ) {
        if (publishFlowItems[fieldName] === 'true') {
          publishFlowItems[fieldName] = true
        } else if (publishFlowItems[fieldName] === 'false') {
          publishFlowItems[fieldName] = false
        } else {
          publishFlowItems[fieldName] = null
        }
      }
    })

    if (
      (publishFlowItems.CounselorLed || publishFlowItems.TeacherLed) &&
      publishFlowItems.ImplementationType
    ) {
      planProgressNumber++
    }

    if (publishFlowItems.Purpose?.length > 0) {
      planProgressNumber++
    }

    if (publishFlowItems.LessonCompletionGoalIsDisabled) {
      if (
        !!publishFlowItems.ClassCreationGoalValue &&
        !!publishFlowItems.ClassCreationGoalDate
      ) {
        planProgressNumber++
      }
    } else {
      if (
        !!publishFlowItems.ClassCreationGoalValue &&
        !!publishFlowItems.ClassCreationGoalDate &&
        !!publishFlowItems.LessonCompletionGoalValue &&
        !!publishFlowItems.LessonCompletionGoalDate &&
        !!publishFlowItems.ProgramStartDate
      ) {
        planProgressNumber++
      }
    }

    if (planProgressNumber === 3) {
      planProgressStatus = 'Complete'
    } else if (planProgressNumber > 0) {
      planProgressStatus = 'In Progress'
    }

    if (launchProgressNumber === 3) {
      launchProgressStatus = 'Complete'
    } else if (launchProgressNumber > 0) {
      launchProgressStatus = 'In Progress'
    }

    return {
      ...site,
      planProgressNumber,
      planProgressStatus,
      launchProgressNumber,
      launchProgressStatus,
    }
  })
}
